import React from "react";
import PropTypes from "prop-types";
import { BannerBlock } from "./BannerBlock";
import { InfoBlock } from "./InfoBlock";
import { QuoteBlock } from "./QuoteBlock";
import { SectionBlock } from "./SectionBlock";

const Block = ({ type, ...rest }) => {
  switch (type) {
    case "banner":
      return <BannerBlock {...rest} />;

    case "info":
      return <InfoBlock {...rest} />;

    case "quote":
      return <QuoteBlock {...rest} />;

    case "section":
      return <SectionBlock {...rest} />;

    default:
      return null;
  }
};

Block.propTypes = {
  type: PropTypes.string.isRequired,
};

export default Block;
